/**
 * homeMenuStore.js — tiny shared signal so the HomeMenu open-state can
 * be driven from outside the HomeMenu component (e.g. the HamburgerTrigger
 * and the taskbar Start button).
 */
import { createSignal } from 'solid-js';

const [open, setOpen] = createSignal(false);
const [pendingTab, setPendingTab] = createSignal(null);

export const homeMenu = {
  open,
  setOpen,
  pendingTab,
  setPendingTab,
  openWith(tab) {
    if (tab) setPendingTab(tab);
    setOpen(true);
  },
  toggle() { setOpen(v => !v); },
  close() { setOpen(false); },
};

export default homeMenu;
